import { 
    GET_ANALYSIS, 
    GET_STORY,
    GET_FULL_STORY,
    GET_STORY_CHAPTERS,
    GET_STORY_CHAPTERS_FAIL,
    REMOVE_ANALYSIS, 
    GET_BOOK_SUCCESS, 
    GET_BOOK_FAIL, 
    POST_PLAYTIME_SUCCESS, 
    POST_PLAYTIME_FAIL, 
    SAVE_LOCAL_DATA,
    GET_STORY_FAIL,
    GET_FULL_STORY_FAIL,
    GET_STORY_LENGTH,
    GET_STORY_LENGTH_FAIL,
    DELETE_STORY,
    ADD_LAZY_FLAG,
    RESET_LAZY_FLAG
} from '../constants/buddyBooks';
import { GAME_URL } from '../constants';
import axios from 'axios';
import { LOGIN_FAIL } from '../constants/auth';
import _ from 'lodash';

window.getStoryCalled = false;
window.getStoryChaptersCalled = false;
window.getStoryAsLazyCalled = false;

export const runAnalysis = (speechId, 
    bookId, blob, segmentIndex, superBuffer, reviewId = null) => {
    // var url = `${GAME_URL}/speech/${person.info?.personId}/analysis/${speechId}`;
    // let savedUser = localStorage.getItem("logged_user");
    // const person = savedUser && JSON.parse(savedUser);
    let savedUser = localStorage.getItem("logged_user");
    const person = savedUser && JSON.parse(savedUser);
    let studentId = person?.info?.personId;
    var url = `${GAME_URL}/speech/${studentId}/analysis/${speechId}/WAV`;
    const data = new FormData();
    data.append("file", blob, "filename.wav");
    return (dispatch, getState) => {
        const state = getState();
        console.log("runAnalysis ~ state", state)
        console.log("buddyBooks.js ~ action ~ runAnalysis ~ reviewId", reviewId);
        const { platform: { analysis, auth } } = state;
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
                'access-token': `${auth.token}`
            }
        };
        axios
            .post(url, data, config)
            .then((response) => {
                let speechObj = {
                    analysis: JSON.parse(response.data.analysis),
                    index: segmentIndex,
                    blob: superBuffer
                };
                console.log('runAnalysis success');
                // let serverResponse = getServerResponse(speechObj, analysis.server_response, response.data, bookId);
                saveScoreToServer(bookId, segmentIndex, response.data.id, auth.token, reviewId);
                
                dispatch({
                    type: GET_ANALYSIS,
                    speechData: response.data,
                });
            })
            .catch(err => console.log(err))
    }
};

export const saveScoreToServer = (bookId, segment, data, sessionId, reviewId) => {
    let savedUser = localStorage.getItem("logged_user");
    const person = savedUser && JSON.parse(savedUser);
    const url = `${GAME_URL}/buddy-books/save`;
    const config = {
        headers: {
            'content-type': 'application/json',
            'access-token': `${sessionId}`
        }
    };
    const buddyScore = {
        currentSection: JSON.stringify(segment),
        data: data,
        bookId: bookId,
        studentId: person.info?.personId,
        session: sessionId,
        reviewId
    };
    console.log('score posted');
    axios.post(url, buddyScore, config);
}

export const removeAnalysis = () => {
    return {
        type: REMOVE_ANALYSIS
    }
}

export const getBook = () => {
    let savedUser = localStorage.getItem("logged_user");
    const person = savedUser && JSON.parse(savedUser);
    let studentId = person?.info?.personId;
    console.log("bb getBook ~ studentId", studentId)
    return async (dispatch, getState) => {
        const state = getState();
        const url = `${GAME_URL}/buddy-books/student/${studentId}`;
        const config = {
            url,
            headers: {
                "access-token": `${state.platform.auth.token}`
            }
        }
        try {
            var res = await axios(config);
            console.log("getBook success ", res.data);
            dispatch({
                type: GET_BOOK_SUCCESS,
                payload: res.data
            })
        } catch (err) {
            console.log("get book err ", err.response)
            dispatch({
                type: LOGIN_FAIL
            })
            dispatch({
                type: GET_BOOK_FAIL
            })
        }
    }
}

export const getStory = (storyId) => {
    console.log('getStory called');
    var url = `${GAME_URL}/buddy-books/story/${storyId}`;
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const config = {
                url,
                headers: {
                    "access-token": `${state.platform.auth.token}`
                }
            };
            var res = await axios(config);
            window.getStoryCalled = true;
            console.log("story success ", res.data);
            dispatch({
                type: GET_FULL_STORY,
                story: res.data
            })
        } catch (err) {
            console.log("getStory err ",err);
            dispatch({
                type: GET_FULL_STORY_FAIL,
            })
        }
    }
};

export const getStoryChapters = (storyId) => {
    console.log('getStoryChapters called');
    var url = `${GAME_URL}/buddy-books/story/${storyId}/chapters`;
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const config = {
                url,
                headers: {
                    "access-token": `${state.platform.auth.token}`
                }
            };
            var res = await axios(config);
            window.getStoryChaptersCalled = true;
            console.log("getStoryChapters success ", res.data);
            dispatch({
                type: GET_STORY_CHAPTERS,
                storyChapters: res.data
            })
        } catch (err) {
            console.log("getStoryChapters err ",err);
            dispatch({
                type: GET_STORY_CHAPTERS_FAIL,
            })
        }
    }
};

export const getStoryAsLazy = (storyId, groupStart=0, groupCount=100, flag = false) => {
    console.log('getStoryAsLazy called');
    var url = `${GAME_URL}/buddy-books/story/${storyId}/lazy`;
    const params = new URLSearchParams();
    params.append('sectionStart', groupStart);
    params.append('sectionCount', groupCount);
    return async (dispatch, getState) => {
        try {
            const state = getState();
            let response;
            const config = {
                url,
                params,
                headers: {
                    "access-token": `${state.platform.auth.token}`
                }
            };
            var res = await axios(config);
            window.getStoryAsLazyCalled = true;
            console.log("getStoryAsLazy success ", res.data);
            if (flag && !_.isEmpty(state.platform.story)) {
                response = {
                    ...res.data, 
                    storySegmentDto: [...state.platform.story.storySegmentDto, ...res.data.storySegmentDto]
                };
                dispatch({
                    type: ADD_LAZY_FLAG,
                    payload: flag
                })
            }
            dispatch({
                type: GET_STORY,
                story: response ? response : res.data
            })
        } catch (err) {
            console.log("getStoryAsLazy err ",err);
            dispatch({
                type: GET_STORY_FAIL,
            })
        }
    }
};

export const resetLazyFlag = () => {
    return {
        type: RESET_LAZY_FLAG,
        payload: false
    }
}

export const getStoryLength = (storyId) => {
    console.log('getStoryLength called');
    var url = `${GAME_URL}/buddy-books/story/${storyId}/total-count`;
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const config = {
                url,
                headers: {
                    "access-token": `${state.platform.auth.token}`
                }
            };
            var res = await axios(config);
            window.getStoryLengthCalled = true;
            console.log("getStoryLength success ", res.data);
            dispatch({
                type: GET_STORY_LENGTH,
                length: res.data
            })
        } catch (err) {
            console.log("getStoryLength err ",err);
            dispatch({
                type: GET_STORY_LENGTH_FAIL,
            })
        }
    }
};

export const postPlaytime = () => {
    let savedUser = localStorage.getItem("logged_user");
    const person = savedUser && JSON.parse(savedUser);
    let studentId = person?.info?.personId;

    return async (dispatch, getState) => {
        const state = getState();
        const url = `${GAME_URL}/students/${studentId}/play-time`;
        var myDate = new Date();
        var date = myDate.getTime();
        const data = [{
            date,
            studentId,
            time: 60
        }]
        const config = {
            method: "POST",
            url,
            data,
            headers: {
                'access-token': `${state.platform.auth.token}`
            }
        }
        try {
            await axios(config);
            dispatch({
                type: POST_PLAYTIME_SUCCESS
            })
        } catch (err) {
            dispatch({
                type: POST_PLAYTIME_FAIL
            })
        }
    }
}

export const localState = (data) => {
    console.log("Local state called")
    return ({
        type: SAVE_LOCAL_DATA,
        isSkippedToSearch: data.isSkippedToSearch,
        isSkipStoryUpdated: data.isSkipStoryUpdated,
        queryText: data.queryText,
        isNotPronounced: data.isNotPronounced,
        isNextHundredStoryAdded : data.isNextHundredStoryAdded
    })
}

export const deleteStory = (data) => {
    return ({
        type: DELETE_STORY,
    })
}